<template>
  <b-modal id="rolesModal" title="Роли" ref="rolesModal"
      header-bg-variant="primary" header-text-variant="light"
      ok-title="Сохранить" cancel-title="Отмена" ok-variant="primary"
      cancel-variant="outline-primary"
      @ok="onSave" :ok-disabled="okDisabled"
    >
      <b-input-group class="mb-3" v-for="(role, index) in roles" :key="index">
        <b-form-input
          :value="role"
          placeholder="Введите название роли"
          @input="onRoleChange(index, $event)"
        ></b-form-input>
        <b-input-group-append>
          <b-button variant="primary"
            v-b-tooltip.hover
            title="Удалить роль"
            @click="onDeleteRole(index)"
            >
              <em class="fas fa-times"/>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    <b-input-group>
      <b-form-input v-model="newRole" placeholder="Добавить роль"></b-form-input>
      <b-input-group-append>
        <b-button variant="primary"
          v-b-tooltip.hover
          title="Добавить роль"
          @click="onAddRole()"
          >
            <em class="fas fa-plus "/>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <error-list :errors="errors" class="mt-2" />
  </b-modal>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import ErrorList from '@/components/content/education/training/tools/ErrorList.vue'

/**
 * Модальное окно для редактирования ролей
 */
export default {
  name: 'RolesModal',
  data() {
    return {
      newRole: '',
      roles: [],
      errors: []
    }
  },
  components: {
    ErrorList
  },
  mounted() {
    this.roles = this.course.roles.slice()
  },
  methods: {
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater'
    }),
    onRoleChange(index, newRole) {
      this.roles[index] = newRole
      this.validateRoles()
    },
    onDeleteRole(index) {
      this.roles.splice(index, 1)
      this.validateRoles()
    },
    onAddRole() {
      this.roles.push(this.newRole)
      this.newRole = ''
      this.validateRoles()
    },
    onSave() {
      this.validateRoles()
      if (this.errors.length === 0) {
        this.course.roles = this.roles
        this.updateUpdater()
      }
    },
    validateRoles() {
      this.errors = this.course.validateRoles(this.roles)
    }
  },
  computed: {
    ...mapGetters({
      course: 'training/getTrainingCourse'
    }),
    okDisabled() {
      return this.errors.length !== 0
    }
  }
}
</script>

<style scoped>

</style>
